import React from "react";

const ListDetail = (params: {
  label: string;
  value?: string;
  content?: JSX.Element;
}) => {
  return (
    <div className="flex flex-col border-b border-b-primary pb-2">
      <label className="text-[0.5rem]">
        {params.label?.replaceAll("_", " ")?.toUpperCase()}
      </label>
      {params.content || (
        <span className="font-bold">{params.value || "-"}</span>
      )}
    </div>
  );
};

export default ListDetail;
